import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const ReductionLandingPage = lazyWithChunkReload(() =>
  import("./landing/reduction-landing.main").then((m) => ({ default: m.ReductionLandingPage }))
);
export const ReductionBaselinePage = lazyWithChunkReload(() =>
  import("./baseline/reduction-baseline.main").then((m) => ({
    default: m.ReductionBaselinePage,
  }))
);
export const ReductionMeasuresPage = lazyWithChunkReload(() =>
  import("./measures/reduction-measures.main").then((m) => ({
    default: m.ReductionMeasuresPage,
  }))
);
export const ReductionRoadmapPage = lazyWithChunkReload(() =>
  import("./roadmap/reduction-roadmap.main").then((m) => ({
    default: m.ReductionRoadmapPage,
  }))
);
export const ReductionScenariosPage = lazyWithChunkReload(() =>
  import("./scenarios/reduction-scenarios.main").then((m) => ({
    default: m.ReductionScenariosPage,
  }))
);
export const ReductionWizardLayout = lazyWithChunkReload(() =>
  import("./shared/wizard/reduction-wizard-layout.main").then((m) => ({
    default: m.ReductionWizardLayout,
  }))
);
